export const labels = {
	deleteTooltip: {
		label: "Label.MobileCreator.Tooltip.Delete",
		default: "Delete",
	},
} as const;
